import React, { useEffect, useState } from "react";
import axios from "axios";
// import * as XLSX from "xlsx"; // eliminado: descarga local por página
import { TableVirtuoso } from "react-virtuoso";
import BotonVolver from "../../../components/BotonVolver";

const estadosDisponibles = ["pedido", "comprado", "en reparto", "entregado", "en la puerta"];
const estadoColores = {
  pedido: "#EE82EE",
  comprado: "#3b82f6",
  "en reparto": "#f59e0b",
  entregado: "#10b981",
  "en la puerta": "#d12b39ff",
};

// Helpers de color (igual que en VerCompras) y normalización de texto
function hexToRgb(hex) {
  if (!hex) return null;
  let h = hex.replace('#', '').trim();
  if (h.length === 3) h = h.split('').map(ch => ch + ch).join('');
  if (h.length === 8) h = h.slice(0, 6);
  const bigint = parseInt(h, 16);
  if (Number.isNaN(bigint)) return null;
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return { r, g, b };
}
function getEstadoColors(estado) {
  const hex = estadoColores[estado];
  const rgb = hexToRgb(hex);
  if (!rgb) return { bg: undefined, border: undefined, text: undefined };
  const { r, g, b } = rgb;
  return { bg: `rgba(${r}, ${g}, ${b}, 0.12)`, border: hex, text: hex };
}
const normalizeText = (s) => {
  if (!s) return '';
  try {
    return String(s).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  } catch {
    return String(s).toLowerCase();
  }
};

const PanelDescargas = () => {
  // Estado para paginación y datos aplanados del backend
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [total, setTotal] = useState(0);
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const [filtros, setFiltros] = useState({
    supervisora: "",
    piso: "",
    estado: "",
    ruta: "",
    fechaInicio: "",
    fechaFin: "",
    buscador: "",
  });
  const [opciones, setOpciones] = useState({ supervisoras: [], pisos: [], rutas: [] });
  const [exportStatus, setExportStatus] = useState('idle'); // 'idle'|'loading'|'success'|'error'
  const [exportMsg, setExportMsg] = useState('');

  const handleExport = async () => {
    setExportStatus('loading');
    setExportMsg('');
    try {
      const params = new URLSearchParams();
      if (filtros.supervisora) params.set('supervisora', filtros.supervisora);
      if (filtros.piso) params.set('piso', filtros.piso);
      if (filtros.estado) params.set('estado', filtros.estado);
      if (filtros.ruta) params.set('ruta', filtros.ruta);
      if (filtros.fechaInicio) params.set('fechaInicio', filtros.fechaInicio);
      if (filtros.fechaFin) params.set('fechaFin', filtros.fechaFin);
      if (filtros.buscador) params.set('buscador', filtros.buscador);
      const url = `/api/descargas/export?${params.toString()}`;
      const token = localStorage.getItem('access_token');
      const res = await fetch(url, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
      if (!res.ok) throw new Error('El servidor devolvió un error');
      const cd = res.headers.get('Content-Disposition') || '';
      const match = cd.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : 'compras_filtradas.xlsx';
      const blob = await res.blob();
      const a = document.createElement('a');
      const dlUrl = URL.createObjectURL(blob);
      a.href = dlUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(dlUrl);
      setExportStatus('success');
      setTimeout(() => setExportStatus('idle'), 3000);
    } catch (e) {
      setExportMsg(e.message || 'No se pudo exportar');
      setExportStatus('error');
    }
  };

  // Cargar opciones y primera página
  useEffect(() => {
    const cargarOpciones = async () => {
      try {
        const res = await axios.get(`/api/descargas/options`);
        setOpciones({
          supervisoras: Array.isArray(res.data?.supervisoras) ? res.data.supervisoras : [],
          pisos: Array.isArray(res.data?.pisos) ? res.data.pisos : [],
          rutas: Array.isArray(res.data?.rutas) ? res.data.rutas : [],
        });
      } catch (e) {
        setOpciones({ supervisoras: [], pisos: [], rutas: [] });
      }
    };
    cargarOpciones();
  }, []);

  const fetchRows = async (nextPage = page, nextFilters = filtros, nextPageSize = pageSize) => {
    try {
      const params = new URLSearchParams();
      params.set('page', String(nextPage));
      params.set('pageSize', String(nextPageSize));
      if (nextFilters.supervisora) params.set('supervisora', nextFilters.supervisora);
      if (nextFilters.piso) params.set('piso', nextFilters.piso);
      if (nextFilters.estado) params.set('estado', nextFilters.estado);
      if (nextFilters.ruta) params.set('ruta', nextFilters.ruta);
      if (nextFilters.fechaInicio) params.set('fechaInicio', nextFilters.fechaInicio);
      if (nextFilters.fechaFin) params.set('fechaFin', nextFilters.fechaFin);
      if (nextFilters.buscador) params.set('buscador', nextFilters.buscador);
      const url = `/api/descargas/rows?${params.toString()}`;
      const res = await axios.get(url);
      setRows(Array.isArray(res.data?.items) ? res.data.items : []);
      setTotal(Number(res.data?.total || 0));
      setPage(Number(res.data?.page || nextPage));
      setPageSize(Number(res.data?.pageSize || nextPageSize));
    } catch (e) {
      setRows([]);
      setTotal(0);
    }
  };

  const handleChange = (tipo, valor) => {
    setFiltros((prev) => ({ ...prev, [tipo]: valor }));
  };

  // Refrescar cuando cambian los filtros (resetea a página 1)
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchRows(1, filtros);
    }, 150);
    return () => clearTimeout(timer);
  }, [filtros]);

// Ya vienen aplanados desde backend, no hay que volver a filtrar aquí
const data = rows;

  const selectStyle = {
    padding: "8px 12px",
    fontSize: "16px",
    height: "40px",
    boxSizing: "border-box",
    border: "1px solid #ccc",
    borderRadius: "4px",
    outline: "none",
    fontFamily: "inherit",
    flexShrink: 0,
    minWidth: "160px",
    marginRight: "12px",
  };

// eliminar helper descargarExcel: ahora solo exporta el backend con todo el filtrado

  // --- Columnas de la tabla ---
  const columns = [
    { key: "_estado_color", label: "", width: 10 },
    { key: "id", label: "ID", width: 70 },
    { key: "abreviatura_piso", label: "Piso", width: 120 },
    { key: "user_supervisora", label: "Superv.", width: 120 },
    { key: "user_comprador", label: "Comprador", width: 130 },
    { key: "user_repartidor", label: "Repartidor", width: 130 },
    { key: "nombre", label: "Producto", width: 260 },
    { key: "unidades", label: "Uds", width: 80 },
    { key: "precio", label: "Precio Ud", width: 110 },
    { key: "precio_total", label: "Precio Total", width: 130 },
    { key: "categoria", label: "Categoría", width: 140 },
    { key: "subcategoria", label: "Subcategoría", width: 160 },
    { key: "dia_pedido", label: "Fecha pedido", width: 170 },
    { key: "estado", label: "Estado", width: 120 },
  ];
  const totalWidth = columns.reduce((acc, c) => acc + c.width, 0);
  const viewportH = typeof window !== "undefined" ? window.innerHeight : 800;
  const tableHeight = Math.min(650, Math.max(320, Math.floor(viewportH * 0.65)));


  return (
    <div
      style={{
        padding: "20px",
        backgroundColor: "#f3f4f6",
        minHeight: "100vh",
        position: "relative",
      }}
    >
      <BotonVolver fallback="/admin" />
      <h2
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          marginBottom: "16px",
        }}
      >
        Panel de Compras
      </h2>

      {/* FILTROS */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          marginBottom: "20px",
          alignItems: "center",
        }}
      >
        <input
          type="text"
          placeholder="Buscar producto..."
          value={filtros.buscador}
          onChange={(e) => handleChange("buscador", e.target.value)}
          style={{ ...selectStyle, flex: "1" }}
        />

        <input
          list="supervisoras"
          placeholder="Supervisora..."
          value={filtros.supervisora}
          onChange={(e) => handleChange("supervisora", e.target.value)}
          style={selectStyle}
        />
        <datalist id="supervisoras">
          {opciones.supervisoras.map((s) => (
            <option key={s} value={s} />
          ))}
        </datalist>

        <input
          list="pisos"
          placeholder="Piso..."
          value={filtros.piso}
          onChange={(e) => handleChange("piso", e.target.value)}
          style={selectStyle}
        />
        <datalist id="pisos">
          {opciones.pisos.map((p) => (
            <option key={p} value={p} />
          ))}
        </datalist>

        <select
          value={filtros.estado}
          onChange={(e) => handleChange("estado", e.target.value)}
          style={{
            ...selectStyle,
            height: "44px",
            fontWeight: 700,
            color: filtros.estado ? (getEstadoColors(filtros.estado).text || "#000") : undefined,
            backgroundColor: filtros.estado ? getEstadoColors(filtros.estado).bg : undefined,
            border: filtros.estado ? `2px solid ${getEstadoColors(filtros.estado).border}` : selectStyle.border,
          }}
        >
          <option value="">Todos los estados</option>
          {estadosDisponibles.map((e) => {
            const ec = getEstadoColors(e);
            return (
              <option key={e} value={e} style={{ color: ec.text, backgroundColor: ec.bg }}>
                {e}
              </option>
            );
          })}
        </select>

        <select
          value={filtros.ruta}
          onChange={(e) => handleChange("ruta", e.target.value)}
          style={{ ...selectStyle, height: "44px" }}
        >
          <option value="">Todas las rutas</option>
          {opciones.rutas.map((r) => (
            <option key={r} value={String(r)}>Ruta {r}</option>
          ))}
        </select>

        <input
          type="date"
          value={filtros.fechaInicio}
          onChange={(e) => handleChange("fechaInicio", e.target.value)}
          style={selectStyle}
        />

        <input
          type="date"
          value={filtros.fechaFin}
          onChange={(e) => handleChange("fechaFin", e.target.value)}
          style={selectStyle}
        />

        <button
          onClick={() => setFiltros({ supervisora: "", piso: "", estado: "", ruta: "", fechaInicio: "", fechaFin: "", buscador: "" })}
          style={{
            ...selectStyle,
            cursor: 'pointer',
            background: '#fff',
            fontWeight: 700,
            border: '4px solid #000',
            borderRadius: '999px',
            padding: '10px 18px',
            boxShadow: '0 4px 0 #000',
            transition: 'transform 0.06s ease, box-shadow 0.06s ease, background 0.2s ease',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px'
          }}
          onMouseEnter={e => { e.currentTarget.style.background = '#f5f5f5'; }}
          onMouseLeave={e => { e.currentTarget.style.background = '#fff'; }}
          onMouseDown={e => { e.currentTarget.style.transform = 'translateY(2px)'; e.currentTarget.style.boxShadow = '0 2px 0 #000'; }}
          onMouseUp={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 0 #000'; }}
          title="Limpiar filtros"
          aria-label="Limpiar filtros"
        >
          <span>🧹</span>
          <span>Limpiar</span>
        </button>

        {/* Exportar todo el filtrado (XLSX desde backend) */}
        <button
          disabled={exportStatus === 'loading'}
          onClick={handleExport}
          style={{
            ...selectStyle,
            cursor: exportStatus === 'loading' ? 'not-allowed' : 'pointer',
            background: exportStatus === 'loading' ? '#6b7280' : '#16a34a',
            color: '#fff',
            border: exportStatus === 'loading' ? '2px solid #4b5563' : '2px solid #14532d',
            borderRadius: '10px',
            fontWeight: 700,
            minWidth: 160,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
          }}
          title="Exportar todo el filtrado como XLSX"
        >
          <span>📥</span><span>Exportar XLSX</span>
        </button>
      </div>

      {/* Modal de exportación centrado */}
      {exportStatus !== 'idle' && (
        <div
          onClick={exportStatus === 'error' ? () => setExportStatus('idle') : undefined}
          style={{
            position: 'fixed', inset: 0,
            zIndex: 9999,
            background: 'rgba(15,23,42,0.45)',
            backdropFilter: 'blur(4px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            animation: 'fadeInOverlay 0.25s ease both',
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: 20,
              boxShadow: '0 24px 64px rgba(0,0,0,0.22)',
              padding: '40px 48px',
              minWidth: 320,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 14,
              animation: 'popInCard 0.35s cubic-bezier(.34,1.56,.64,1) both',
              border: exportStatus === 'error'   ? '2px solid #fca5a5'
                    : exportStatus === 'success' ? '2px solid #86efac'
                    : '2px solid #bfdbfe',
            }}
          >
            {exportStatus === 'loading' && (
              <>
                <div style={{
                  width: 56, height: 56,
                  border: '5px solid #dbeafe',
                  borderTop: '5px solid #2563eb',
                  borderRadius: '50%',
                  animation: 'spin360 0.75s linear infinite',
                  marginBottom: 4,
                }} />
                <span style={{ fontWeight: 800, fontSize: 18, color: '#1e3a8a', letterSpacing: '-0.3px' }}>Generando Excel…</span>
                <span style={{ color: '#64748b', fontSize: 14 }}>Esto puede tardar unos segundos</span>
              </>
            )}
            {exportStatus === 'success' && (
              <>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: '#dcfce7',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 34, marginBottom: 4,
                }}>✅</div>
                <span style={{ fontWeight: 800, fontSize: 18, color: '#14532d' }}>¡Descarga iniciada!</span>
                <span style={{ color: '#64748b', fontSize: 14 }}>El archivo XLSX se está descargando</span>
                <span style={{ color: '#94a3b8', fontSize: 12, marginTop: -4 }}>Esta ventana se cerrará sola</span>
              </>
            )}
            {exportStatus === 'error' && (
              <>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  background: '#fee2e2',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 34, marginBottom: 4,
                }}>❌</div>
                <span style={{ fontWeight: 800, fontSize: 18, color: '#7f1d1d' }}>Error al exportar</span>
                <span style={{ color: '#64748b', fontSize: 14, textAlign: 'center', maxWidth: 260 }}>{exportMsg}</span>
                <button
                  onClick={() => setExportStatus('idle')}
                  style={{
                    marginTop: 8, padding: '9px 28px',
                    background: '#ef4444', color: '#fff',
                    border: 'none', borderRadius: 10,
                    fontWeight: 700, cursor: 'pointer', fontSize: 14,
                    boxShadow: '0 2px 8px rgba(239,68,68,0.3)',
                  }}
                >Cerrar</button>
              </>
            )}
          </div>
        </div>
      )}
      <style>{`
        @keyframes fadeInOverlay {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
        @keyframes popInCard {
          from { opacity: 0; transform: scale(0.88) translateY(16px); }
          to   { opacity: 1; transform: scale(1) translateY(0); }
        }
        @keyframes spin360 {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
      `}</style>

      {/* TABLA VIRTUALIZADA (react-virtuoso) */}
      <div
        style={{
          overflowX: "auto",
          backgroundColor: "#fff",
          borderRadius: "8px",
          padding: "8px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <TableVirtuoso
          data={data}
          style={{ height: tableHeight, width: totalWidth }}
          fixedHeaderContent={() => (
            <tr>
              {columns.map((c) => (
                <th
                  key={c.key}
                  style={{
                    position: "sticky",
                    top: 0,
                    background: "#e5e7eb",
                    border: "1px solid #d1d5db",
                    padding: "8px",
                    textAlign: "left",
                    width: c.width,
                  }}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          )}
          itemContent={(index, row) => (
            <>
              {/* barra izquierda de color según estado */}
              <td style={{ width: 10, padding: 0, border: '1px solid #d1d5db', backgroundColor: estadoColores[row.estado] || '#ccc' }} />
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.id}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.abreviatura_piso}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.user_supervisora}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.user_comprador}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.user_repartidor}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.nombre}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.unidades}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.precio}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.precio_total}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.categoria}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.subcategoria}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px" }}>{row.dia_pedido || ""}</td>
              <td style={{ border: "1px solid #d1d5db", padding: "8px", color: estadoColores[row.estado] || "#000" }}>{row.estado}</td>
            </>
          )}
          increaseViewportBy={{ top: 200, bottom: 600 }}
        />
      </div>

      {/* Botón de descarga local eliminado, usamos solo Exportar todo (backend) */}

      {/* Paginación simple */}
      <div style={{ display:'flex', gap:8, alignItems:'center', justifyContent:'center', marginTop: 12 }}>
        <button
          onClick={() => { if (page > 1) fetchRows(page - 1); }}
          disabled={page <= 1}
          style={{ padding:'6px 10px' }}
        >
          ◀ Anterior
        </button>
        <span style={{ fontWeight:700 }}>
          Página {page} / {totalPages} · {total} filas
        </span>
        <button
          onClick={() => { if (page < totalPages) fetchRows(page + 1); }}
          disabled={page >= totalPages}
          style={{ padding:'6px 10px' }}
        >
          Siguiente ▶
        </button>
      </div>
    </div>
  );
};

export default PanelDescargas;
